<template>
  <div class="app" :class="{
    'app--loading': isLoading,
  }">
    <header class="app__header">
      <TheHeader />
    </header>

    <div class="app__menu" v-if="isMenuVisible">
      <TheMenu />
    </div>

    <main class="app__content">
      <transition name="" mode="out-in" appear>
        <router-view :key="$route.fullPath" />
      </transition>
    </main>

    <footer class="app__footer">
      <TheFooter />
    </footer>

    <div class="app__cookies" v-if="!cookieInfoHidden">
      <div class="app__cookies__content">
        <p class="app__cookies__text">
          <span>{{ $t('cookieBox.header') }}</span><br /><br />
          <span v-html="$t('cookieBox.text')"></span>
        </p>

        <div class="app__cookies__hide" @click="hideCookiesInfo()">X</div>
      </div>
    </div>
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue';
import TheMenu from '@/components/TheMenu.vue';
import TheFooter from '@/components/TheFooter.vue';
import LocationService from '@/services/LocationService.js';

export default {
  name: 'App',

  components: {
    TheHeader,
    TheMenu,
    TheFooter,
  },

  data: () => ({
    isLoading: false,
    cookieInfoHidden: !!JSON.parse(localStorage.getItem('PP:cookieInfoHidden')),
  }),

  async mounted() {
    this.isLoading = true;
    await this.updateLocale();
    this.isLoading = false;
  },

  computed: {
    isMenuVisible() {
      return this.$route.fullPath !== '/';
    },
  },

  methods: {
    async updateLocale() {
      const storedLocale = JSON.parse(localStorage.getItem('PP2021:locale'));
      const hasStoredLocale = !!storedLocale;

      if (hasStoredLocale) {
        this.$i18n.locale = storedLocale;

        return;
      }

      // const browserLocale = await LocationService.getCountryCode();
      const browserLocale = 'cz';

      // const defaultLocale = ['bg', 'cz', 'hu', 'pl', 'ro'].find(locale => locale === browserLocale);
      const defaultLocale = ['cz', 'hu', 'ro'].find(locale => locale.toLowerCase() === browserLocale.toLowerCase());

      const hasLocale = !!defaultLocale;

      console.log('defaultLocale', defaultLocale);

      if (hasLocale) {
        this.$i18n.locale = defaultLocale;

        localStorage.setItem('PP2021:locale', JSON.stringify(defaultLocale));

        return;
      }

      this.$i18n.locale = 'cz';

      this.$router.push('/language?showInfo=true');
    },

    hideCookiesInfo() {
      this.cookieInfoHidden = true;
      localStorage.setItem('PP2021:cookieInfoHidden', JSON.stringify(true));
    },
  },
};
</script>

<style lang="scss">
@import 'reset-css';
@import '~vue2-animate/dist/vue2-animate.min.css';

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

body {
  background-image: url('~@/assets/background.png');
  background-position: center bottom;
  background-size: 100% 150%;
  background-attachment: fixed;
}

.app {
  overflow: hidden;
  position: relative;

  max-width: 1920px;
  margin: 0 auto;

  padding: 60px 0 40px;

  font-family: Arial, Helvetica, sans-serif;
  color: #ffffff;

  &--loading {
    opacity: 0;
  }

  &__header,
  &__footer {
    position: absolute;
    left: 0;
    width: 100%;
  }

  &__header {
    top: 0;
  }

  &__menu {
    margin: 30px 0 80px;
  }

  &__footer {
    bottom: 0;
  }

  &__cookies {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1100;
    padding: 20px 30px;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.25em;
    text-transform: none;
    text-align: justify;
    color: #fff;
    background-color: #4f4f4f;

    &__content {
      display: flex;
      align-items: center;
      max-width: 960px;
      margin: 0 auto;
    }

    &__hide {
      margin-left: 100px;
      padding: 20px;
      font-size: 13px;
      line-height: 1.25em;
      text-decoration: underline;
      text-align: center;
      cursor: pointer;

      &:hover {
        color: #ffff00;
      }
    }

    a {
      color: inherit;

      &:hover {
        color: #ffff00;
      }
    }
  }

  &--nickelodeon {
    max-width: 910px;
    margin: 0 auto;
  }

  &--debug {
    *,
    *::before,
    *::after {
      outline: 1px solid red;
    }
  }
}
</style>
